var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HznInline_instances, _HznInline_computeSpaceClass;
import { LitElement } from '@horizon/base';
import { property } from '@horizon/base/decorators.js';
import { unsafeStatic, html } from '@horizon/base/static-html.js';
import InlineStyles from './inline.css.js';
import { inlineTags } from '../types.js';
/**
 *
 * @tag hzn-inline
 * @tagname hzn-inline
 * @summary A layout component for establishing a horizontal row of items
 */
export class HznInline extends LitElement {
    constructor() {
        super(...arguments);
        _HznInline_instances.add(this);
        /**
         * Set the gap between inline items. Accepts a single value, or two values separated by a space. When two values are provided the order is space="horizontal vertical", ie space="large small" sets the column-gap to 'small' and the row-gap to large
         */
        this.space = 'base';
        /**
         * Set the HTML element the inline element will render as (div, ol, ul)
         */
        this.as = 'div';
        /**
         * Set the vertical alignment of the child elements relative to each other in their flex row
         */
        this.alignY = 'center';
        /**
         * Set the horizontal alignment of the child elements relative to the hzn-inline container
         */
        this.alignX = 'start';
        /**
         * Reverse the order of inline child elements
         */
        this.reverse = false;
        /**
         * Set inlined child elements to wrap to the next row
         */
        this.wrap = false;
    }
    render() {
        return html `<${unsafeStatic(this.as && inlineTags.includes(this.as) ? this.as : 'div')} class="outer ${__classPrivateFieldGet(this, _HznInline_instances, "m", _HznInline_computeSpaceClass).call(this)}">
      <slot></slot>
    </${unsafeStatic(this.as && inlineTags.includes(this.as) ? this.as : 'div')}>`;
    }
}
_HznInline_instances = new WeakSet(), _HznInline_computeSpaceClass = function _HznInline_computeSpaceClass() {
    if (this.space) {
        const spaceSplit = this.space.split(' ');
        if (spaceSplit.length > 1) {
            return `spacing-${spaceSplit[0]}-${spaceSplit[1]}`;
        }
        return `spacing-${spaceSplit[0]}`;
    }
    return 'spacing-base';
};
HznInline.styles = [InlineStyles];
__decorate([
    property({ type: String, reflect: true })
], HznInline.prototype, "space", void 0);
__decorate([
    property({ type: String })
], HznInline.prototype, "as", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'collapse-below' })
], HznInline.prototype, "collapseBelow", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'align-y' })
], HznInline.prototype, "alignY", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'align-x' })
], HznInline.prototype, "alignX", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HznInline.prototype, "reverse", void 0);
__decorate([
    property({ type: Boolean, attribute: 'wrap', reflect: true })
], HznInline.prototype, "wrap", void 0);
//# sourceMappingURL=inline.js.map